import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import ReactQuill from "react-quill";

import { Text } from "@pentabd/ui";

import {
  InterchangeTransferDetailsFormDataType,
  INTERCHANGE_TRANSFER,
} from "@validations/HRM/interchangeTransfer/interchangeTransferValidation";

interface LetterProps {
  isDisabled: boolean;
  name: string;
}

export const Letter = ({ isDisabled, name }: LetterProps) => {
  const {
    register,
    watch,
    setValue,
    formState: { errors },
  } = useFormContext<InterchangeTransferDetailsFormDataType>();

  useEffect(() => {
    register(name, { required: true });
  }, [register]);

  const editorContent = watch(name);

  const onEditorStateChange = (editorState: any) => {
    setValue(name, editorState, {
      shouldValidate: true,
      shouldDirty: true,
    });
  };

  return (
    <div className="my-8" style={{ display: "none" }}>
      <ReactQuill
        theme="snow"
        // value={editorContent}
        defaultValue={"test"}
        onChange={onEditorStateChange}
        readOnly={isDisabled}
      />
      <Text color="danger" size="sm" className="lh-sm mt-5" component="p">
        {errors?.letter?.message as any}
      </Text>
    </div>
  );
};
